/**
 * Fallback for when `Retry-After` didn't make it to the client: `Retry-After`
 * isn't on the CORS response-header safelist, so a cross-origin API (this
 * one's base URL is configurable, so usually is) silently drops it unless
 * the backend adds `Access-Control-Expose-Headers: Retry-After` -- no client
 * code can work around that. The 429's own message body has no such
 * restriction though, and the API's contract guarantees it always states the
 * wait in minutes (e.g. "Please try again in 15 minute(s)."), in whichever
 * language x-lang asked for -- so pulling the first number out of it and
 * treating it as minutes works regardless of language or that CORS gap.
 */
export function retryAfterSecondsFromMessage(
  message: string,
): number | undefined {
  const match = /\d+/.exec(message);
  if (match === null) return undefined;
  const minutes = Number(match[0]);
  return Number.isFinite(minutes) && minutes > 0 ? minutes * 60 : undefined;
}
